<template>
  <!-- Layout inner -->
  <div class="layout-inner explore_entity_result programs">
    <!-- Layout navbar -->
    <navbar></navbar>
    <!-- / Layout navbar -->
    <div class="layout-container">
      <div class="layout-content">

        <!-- Filter, Search and Sort -->
        <template v-if="showPage">
          <template v-if="!showCreditProgressPopup">

            <div class="sub_hd_bar">

              <div class="sub_hd_ic">
                <span @click="isProgramFilterClicked = true" class="filter" v-if="(isAreaOfStudyEnabled || isSubCategoryEnabled || isCollegeEnabled || isProgramLevelEnabled || isIncomeRangeEnabled || isCustomTagFilterEnabled || isModalityEnabled || isFundingFilterEnabled || isCostRangeEnabled )">
                  <span class="ic ic-filter" :class="selectedFilterCount() > 0 ? 'active' : ''"></span>
                  <template v-if="!isProgramFilterClicked">
                    <span class="count" v-if="selectedFilterCount() > 0">
                      <span>{{selectedFilterCount()}}</span>
                    </span>
                  </template>
                </span>
              </div>

              <div class="srh_bx">
                <input v-if="isSearchBarEnabled" type="text" class="search-input" placeholder="type to narrow results" v-on:keyup.enter="searchButtonClicked" v-model.trim="searchTerms"/>
                <span v-if="isSearchBarEnabled" @click="searchButtonClicked" class="search-icon">
                  <i class="fa fa-search" aria-hidden="true"></i>
                </span>
              </div>

              <div class="sort_by" v-if="isSortByEnabled" @click="openSortByDropDown">
                <span class="sort_by_link">sort by</span>
              </div>

              <div class="list_info">
                Exploring {{total}} {{exploreProgramsLabelPlural}}</span>
              </div>

            </div>

          </template>
        </template>

        <!-- Page content -->
        <div class="container-fluid flex-grow-1 pg_content_container">
          <template v-if="loader">
            <div class="w-100 h-100 d-flex justify-content-center align-items-center">
              <spinner size="large"></spinner>
            </div>
          </template>
          <template v-if="showPage">
            <template v-if="showCreditProgressPopup">
              <explore-program-guide-credit-progress
                :title="selectedProgramGuide.title"
                :stream-id="planningStream.uuid"
                :program-id="selectedProgramGuide.uuid"
                :credit-progress-target-id="creditProgressTargetId">
              </explore-program-guide-credit-progress>
            </template>
            <template v-else>

              <template v-if="isProgramFilterClicked || isProgramSortByClicked">
  	        		<div class="container filter_selection_flds_container">
  	        			<template v-if="isProgramFilterClicked">
  		        			<template v-if="(showAreaOfStudyDropDown || showSubCategoryDropDown || showCollegeDropDown || showProgramLevelDropDown || showIncomeRangeDropDown || isProgramOtherFilterClicked)">

                      <div v-if="isAreaOfStudyEnabled && showAreaOfStudyDropDown">
                        <div class="filter_fld_head">
                          <div class="hd_txt">Select {{areaOfStudyLabel}}</div>
                          <div class="btn_container">
                            <span class="btn_close" @click="closeAreaOfStudyDropDown"></span>
                          </div>
                        </div>
  		        					<div class="filter_fld_container">
  			          				<div v-for="areaOfStudy in formattedFacetResults.programGuideCategory">
		            						<label>
                              <input type="checkbox" :checked="areaOfStudy.isSelected" @input.stop="filterSelected(areaOfStudy, 'programGuideCategory')">
	                               <span class="input_txt">
                                   {{areaOfStudy.key}}
                                   <span v-if="showFacetCounts">[{{areaOfStudy.doc_count}}]</span>
                                 </span>
                               </input>
		            						</label>
  		            				</div>
  		          				</div>
  		          				<div class="btn_container">
  				        				<b-btn @click="closeAreaOfStudyDropDown">ok</b-btn>
  				        			</div>
  		        				</div>

                      <div v-if="isSubCategoryEnabled && showSubCategoryDropDown">
                        <div class="filter_fld_head">
                          <div class="hd_txt">Select {{subCategoryLabel}}</div>
                          <div class="btn_container">
                            <span class="btn_close" @click="closeSubCategoryDropDown"></span>
                          </div>
                        </div>
  		        					<div class="filter_fld_container">
  			          				<div v-for="subCategory in formattedFacetResults.programGuideSubCategory">
  		            					<div>
  		            						<label>
                                <input type="checkbox" :checked="subCategory.isSelected" @input.stop="filterSelected(subCategory, 'programGuideSubCategory')">
  	                               <span class="input_txt">
                                     {{subCategory.key}}
                                     <span v-if="showFacetCounts">[{{subCategory.doc_count}}]</span></input>
                                   </span>
  		            						</label>
  		            					</div>
  		            				</div>
  		          				</div>
  		          				<div class="btn_container">
  				        				<b-btn @click="closeSubCategoryDropDown">ok</b-btn>
  				        			</div>
  		        				</div>

                      <div v-if="isCollegeEnabled && showCollegeDropDown">
                        <div class="filter_fld_head">
                          <div class="hd_txt">Select {{collegeLabel}}</div>
                          <div class="btn_container">
                            <span class="btn_close" @click="closeCollegeDropDown"></span>
                          </div>
                        </div>
  		        					<div class="filter_fld_container">
  			          				<div v-for="college in formattedFacetResults.programGuideCollege">
		            						<label>
                              <input type="checkbox" :checked="college.isSelected" @input.stop="filterSelected(college, 'programGuideCollege')">
                                <span class="input_txt">
                                   {{college.key}}
                                   <span v-if="showFacetCounts">[{{college.doc_count}}]</span>
                                 </span>
                               </input>
		            						</label>
  		            				</div>
  		          				</div>
  		          				<div class="btn_container">
  				        				<b-btn @click="closeCollegeDropDown">ok</b-btn>
  				        			</div>
  		        				</div>

  		        				<div v-if="isProgramLevelEnabled && showProgramLevelDropDown">
                        <div class="filter_fld_head">
                          <div class="hd_txt">Select {{programLevelLabel}}</div>
                          <div class="btn_container">
                            <span class="btn_close" @click="closeprogramLevelDropDown"></span>
                          </div>
                        </div>
  		        					<div class="filter_fld_container">
  			        					<template v-for="level in formattedFacetResults.programGuideLevel" >
  			            				<label>
                              <input type="checkbox" :checked="level.isSelected" @input.stop="filterSelected(level, 'programGuideLevel')">
                                <span class="input_txt">
                                  {{level.key}}
                                  <span v-if="showFacetCounts">[{{level.doc_count}}]</span>
                                </span>
                              </input>
  			            				</label>
  			          				</template>
  		        					</div>
  		        	   			<div class="btn_container">
  				        				<b-btn @click="closeprogramLevelDropDown">ok</b-btn>
  				        			</div>
  		        				</div>
                      <div v-if="isProgramOtherFilterClicked">
                        <template v-if="isProgramOtherFilterClicked">
                          <div class="row">
                            <div class="col-12 filter_box">

                              <div class="row" v-if="isCustomTagFilterEnabled">
                                <div class="col-12" v-for="customTag in customTagOptions">
                                  <label>
                                    <input type="checkbox" :checked="isCustomTagChecked(customTag)" @input.stop="filterSelected(customTag, 'programGuideCustomTag')" style="width: 15px; height: 15px;">
                                      <span class="input_txt ml-1">
                                        {{customTag.label}}
                                      </span>
                                    </input>
                                  </label>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-12 field-row filter_fld_label" v-if="isModalityEnabled">
                                  {{modalityLabel}}
                                </div>
                                <div class="col-12 filter_fld_container_1">
                                  <template v-for="mType in programGuideMadalityTypeArray" v-if="isModalityEnabled">
                                    <div class="field-row filter_fld_val">
                                      <input type="checkbox" :checked="isModalityChecked(mType)" @input.stop="filterModalitySelected(mType, 'programGuideModalityType')">
                                      {{mType.value}} </input>
                                    </div>
                                  </template>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-12 field-row filter_fld_label" v-if="isCostRangeEnabled">
                                  {{costRangeLabel}}
                                </div>
                                <div class="col-12 filter_fld_container_1">
                                  <template v-for="range in formattedFacetResults.programGuideCostRange" v-if="isCostRangeEnabled">
                                    <div class="field-row filter_fld_val">
                                      <input type="radio" :checked="range.isSelected" @input.stop="filterSelected(range, 'programGuideCostRange')">
                                      {{range.label}} </input>
                                    </div>
                                  </template>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-12 field-row filter_fld_label" v-if="isFundingFilterEnabled">
                                  {{fundingLabel}}
                                </div>
                                <div class="col-12 filter_fld_container_1">
                                  <template v-for="fType in programGuideFundingTypeArray" v-if="isFundingFilterEnabled">
                                      <div class="field-row filter_fld_val">
                                        <input type="checkbox" :checked="isFundingChecked(fType)" @input.stop="filterFundingSelected(fType, 'programGuideFundingType')">
                                        {{fType.value}} </input>
                                      </div>
                                  </template>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-12 field-row filter_fld_label" v-if="isIncomeRangeEnabled">
                                  {{incomeRangeLabel}}
                                </div>
                                <div class="col-12 filter_fld_container_1">
                                  <template v-for="range in formattedFacetResults.programGuideIncomeRange" v-if="isIncomeRangeEnabled">
                                      <div class="field-row filter_fld_val">
                                        <input type="radio" :checked="range.isSelected" @input.stop="filterSelected(range, 'programGuideIncomeRange')">
                                        {{range.label}} </input>
                                      </div>
                                  </template>
                                </div>
                                <div class="col-12 filter_fld_container_1" v-if="isIncomeRangeEnabled">
                                  <div class="row">
                                    <div class="col-5 mt-2">
                                      <span>min</span>
                                      <b-form-input id="customIncomeMin" v-model="customIncomeMin" number="true" type="number" min="0" class="w90"></b-form-input>
                                    </div>
                                    <div class="col-5 mt-2 ml-2">
                                      <span>max</span>
                                      <b-form-input id="customIncomeMax" v-model="customIncomeMax" number="true" type="number" min="0" class="w90"></b-form-input>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-12 btn_container">
                                  <b-btn @click="closeOtherFilterDropDown">ok</b-btn>
                                </div>
                              </div>

                            </div>
                          </div>
                        </template>

                      </div>


  		        			</template>
  		        			<template v-else>

                      <div class="filter_fld_head">
                        <div class="hd_txt">
                          Select Filter(s)
                        </div>
                      </div>

  		        				<div class="filter_options_container">
  				        			<div v-if="isAreaOfStudyEnabled" @click.stop="openAreaOfStudyDropDown" class="filter_option area_of_study">
  				        				<label for="select-career">
  				        					<span>Select </span>{{areaOfStudyLabel}}
  				        				</label>
  					        		</div>
                        <div v-if="isSubCategoryEnabled" @click.stop="openSubCategoryDropDown" class="filter_option area_of_study">
  				        				<label for="select-career">
  				        					<span>Select </span>{{subCategoryLabel}}
  				        				</label>
  					        		</div>
                        <div v-if="isCollegeEnabled" @click.stop="openCollegeDropDown" class="filter_option area_of_study">
  				        				<label for="select-career">
  				        					<span>Select </span>{{collegeLabel}}
  				        				</label>
  					        		</div>
                        <div v-if="isProgramLevelEnabled" @click.stop="openProgramLevelDropDown" class="filter_option program_level">
  				        				<label for="select-career">
  				        					<span>Select </span>{{programLevelLabel}}
  				        				</label>
  					        		</div>

                        <div v-if="isIncomeRangeEnabled || isModalityEnabled || isCustomTagFilterEnabled || isFundingFilterEnabled"  @click.stop="openOtherFilterDropDown" class="filter_option income_range">
                          <label for="select-income">
                            <span>Other Filters</span>
                          </label>
                        </div>

  			        			</div>

                      <div class="selected_filters_container">
                        <b-input-group>
          	          			<template v-for="areaOfStudy in formattedFacetResults.programGuideCategory">
                              <div v-if="areaOfStudy.isSelected" class="search_tag area_of_study">
                                <span class="title category">{{areaOfStudy.key}}</span>
                                <span class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="filterSelected(areaOfStudy, 'programGuideCategory')">
                                </span>
                              </div>
          	          			</template>
                            <template v-for="subCategory in formattedFacetResults.programGuideSubCategory">
          	          			    <div v-if="subCategory.isSelected" class="search_tag area_of_study">
          	          			      <span class="title category">{{subCategory.key}}</span>
          	            			  <span class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="filterSelected(subCategory, 'programGuideSubCategory')">
          	            			  </span>
          	            			</div>
          	          			</template>
                            <template v-for="college in formattedFacetResults.programGuideCollege">
          	          			    <div v-if="college.isSelected" class="search_tag area_of_study">
          	          			      <span class="title category">{{college.key}}</span>
          	            			  <span class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="filterSelected(college, 'programGuideCollege')">
          	            			  </span>
          	            			</div>
          	          			</template>
          	          			<template v-for="level in formattedFacetResults.programGuideLevel">
          	          			    <div v-if="level.isSelected" class="search_tag program_level">
          	          			      <span class="title type">{{level.key}}</span>
          	            			  <span class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="filterSelected(level, 'programGuideLevel')">
          	            			  </span>
          	            		   </div>
          	          			</template>
          	          			<template v-for="range in formattedFacetResults.programGuideIncomeRange">
          	          			    <div v-if="range.isSelected" class="search_tag income_range">
          	          			       <span class="title income_range">income {{range.label}}</span>
          	            			   <span  class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter">
          	            			   </span>
          	            			</div>
          	          			</template>
                            <template v-for="range in formattedFacetResults.programGuideCostRange">
                                <div v-if="range.isSelected" class="search_tag income_range">
                                   <span class="title income_range">cost {{range.label}}</span>
                                 <span  class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="clearCostRangeFilter">
                                 </span>
                              </div>
                            </template>
                            <template v-if="modalityType.length > 0">
                              <div class="search_tag area_of_study" v-for="m in modalityType">
                                <span class="title type">{{m.value}}</span>
                                <span class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="filterModalitySelected(m, 'programGuideModalityType', true)">
                                </span>
                              </div>
                            </template>
                            <template v-if="fundingType.length > 0">
                              <div class="search_tag area_of_study" v-for="f in fundingType">
                                <span class="title type">{{f.value}}</span>
                                <span class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="filterFundingSelected(f, 'programGuideFundingType', true)">
                                </span>
                              </div>
                            </template>

                            <template v-for="customTag in programGuideCustomTags">
                              <div v-if="customTag.isSelected" class="search_tag area_of_study">
                                <span class="title type">{{customTag.key}} Pathways</span>
                                <span class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="filterSelected(customTag, 'programGuideCustomTag')">
                                </span>
                              </div>
                            </template>
                            <div v-if="programGuideSearchCustomIncomeMax && programGuideSearchCustomIncomeMin" class="search_tag">
                              <span class="title income_range">${{programGuideSearchCustomIncomeMin}} - ${{programGuideSearchCustomIncomeMax}}</span>
                              <span  class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter"></span>
                            </div>
                            <div v-if="programGuideSearchCustomIncomeMax && !programGuideSearchCustomIncomeMin" class="search_tag">
                              <span class="title income_range"> < ${{programGuideSearchCustomIncomeMax}}</span>
                              <span  class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter"></span>
                            </div>
                            <div v-if="!programGuideSearchCustomIncomeMax && programGuideSearchCustomIncomeMin" class="search_tag">
                              <span class="title income_range"> > ${{programGuideSearchCustomIncomeMin}}</span>
                              <span  class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter"></span>
                            </div>
          	        		</b-input-group>

                        <div v-if="selectedFilterCount() === 0" class="no_result">{{ $t('noFilterSelected') }}</div>

  					   				</div>

  			        			<div class="btn_container">
  			        				<b-btn @click="isProgramFilterClicked = false">ok</b-btn>
  			        			</div>

  		        			</template>
  	        			</template>

  	        			<template v-if="isProgramSortByClicked">
                    <div class="filter_fld_head">
                      <div class="hd_txt">
                        Sort by
                      </div>
                    </div>
  	        				<div class="mt-2 ml-4">
  	        					<template v-for="sort in sortByOptions">
  			    						<div class="field-row mb-3">
  			    							<div class="form-check">
  			              			<input type="radio" class="form-check-input" :id="sort.name" :checked="selectedSort" v-model="selectedSort" v-bind:value="sort.clause">
  			              			<label class="form-check-label" :for="sort.name">{{ sort.name }}</label>
  			              		</div>
  			              	</div>
  			  						</template>
  					  	      <div class="btn_container">
  			        				<b-btn @click="closeSortByDropDown">ok</b-btn>
  			        			</div>
  	        				</div>
  	        			</template>
  	        		</div>
  	        	</template>

  	        	<template v-else>
  		        		<template v-if="isResultsLoaded">
  			        		<template v-if="formattedResults.length > 0">
                      <virtual-list
                        class="item-list"
                        :data-key="'uuid'"
                        :data-sources="formattedResults"
                        :data-component="itemComponent"
                        :estimate-size="30"
                        :extra-props="{parent: parentComponent}"
                      />
                    </template>
                    <template v-else>
                      <div class="row">
                        <div class="col-12 no_result mt-5">No result found</div>
                      </div>
                    </template>
  								</template>
  	        	</template>
          	</template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import ExploreProgramGuideCreditProgress from './ExploreProgramGuideCreditProgress'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import _ from 'lodash'
import ProgramItem from './ProgramItem'
import VirtualList from 'vue-virtual-scroll-list'

export default {
  name: 'exploreProgramGuideResults',
  components: {
    Navbar,
    ExploreProgramGuideCreditProgress,
    VirtualList
  },
  data () {
    return {
      loader: true,
      showPage: false,
      itemComponent: ProgramItem,
      size: 500, // NOTE: ElasticSearch needs size parameter set or defaults to 10
      isResultsLoaded: false,
      indexesSelected: [],
      allIndexes: ['programguide'],
      folders: [],
      allFolders: [],
      privateLibraryList: [],
      purchasedPrograms: [],
      publicLibraryList: [],
      libraryList: '',
      searchTerms: '',
      modalityType: [],
      fundingType: [],
      source: [
        'uuid',
        'institutionId',
        'title',
        'description',
        'creationTime',
        'lastUpdatedTime',
        'type',
        'programLevel',
        'medianIncomePerYear',
        'growthRate',
        'growthRateDoubleFormat',
        'totalJobPostings',
        'cipCode',
        'code',
        'thumbnailURL',
        'userExternalId',
        'customTags',
        'lowestPrice',
        'lowestPriceCurrency',
        'cost',
        'modalityType',
        'fundingType',
        'pragyaProgram',
        'freeProgram',
        'paymentProcessedOutOfPragya',
        'disbleLMI',
        '_score'
      ],
      sorts: [
        {name: 'Relevance', clause: [{_score: {order: 'desc'}}]},
        {name: 'Title', clause: [{'title.raw': {order: 'asc'}}]},
        {name: 'Median Income', clause: [{medianIncomePerYear: {order: 'desc'}}]},
        {name: 'Job Postings', clause: [{totalJobPostings: {order: 'desc'}}]},
        {name: 'Growth Rate', clause: [{growthRateDoubleFormat: {order: 'desc'}}]}
      ],
      selectedSort: {},
      validLearningSpaceCategories: {
        LearningSpace: 'LearningSpace',
        Institution: 'Institution',
        Institute_Public: 'Institute_Public',
        User_Private: 'User_Private'
      },
      privateLearningSpaceCategories: {Institute_Public: 'Institute_Public', User_Private: 'User_Private'},
      selectedFacetNames: [],
      facetFieldMap: {
        programGuideCategory: 'category.raw',
        programGuideSubCategory: 'subCategory.raw',
        programGuideCollege: 'colleges.raw',
        programGuideLevel: 'programLevel.keyword',
        programGuideCustomTag: 'customTags.keyword',
        programGuideIncomeRange: 'medianIncomePerYear',
        programGuideCostRange : 'cost',
        programGuideModalityType : 'modalityType',
        programGuideFundingType : 'fundingType'
      },
      filter: {},
      showAreaOfStudyDropDown: false,
      showSubCategoryDropDown: false,
      showCollegeDropDown: false,
      showProgramLevelDropDown: false,
      showIncomeRangeDropDown: false,
      showSortByDropDown: false,
      customIncomeMin: '',
      customIncomeMax: '',
      navigationErrorMessage: 'No CIP data found for this Program Guide. Please re-upload to see more details',
      selectedProgramGuide: null,
      creditProgressTargetId: '',
      showCreditProgressPopup: false,
      isProgramFilterClicked: false,
      isProgramSortByClicked: false,
      isProgramOtherFilterClicked: false,
    }
  },

  created () {
    this.showLoader()
  },

  async mounted () {
    this.showLoader()
    await this.loadUserObj()
    await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
    this.initializeSearchData()
    let allFolders = []
    let publicLibraryList = []
    let privateLibraryList = []
    let validCategories = this.validLearningSpaceCategories
    let privateCategories = this.privateLearningSpaceCategories

    let learningSpaces = await this.loadLibrariesForUser({userId: this.userObj.uuid, userObject: this.userObj})
    let institution = await this.loadInstitutionDetail(this.userObj.institutionId)
    learningSpaces.push(institution)
    for (var i = 0; i < learningSpaces.length; i++) {
      const learningSpace = learningSpaces[i]
      const category = learningSpace.category
      if (!validCategories[category]) {
        continue
      }
      let libraryList = privateCategories[category] ? privateLibraryList : publicLibraryList
      libraryList.push(learningSpace.uuid)
      allFolders.push(learningSpace.uuid)
    }
    this.allFolders = allFolders
    this.publicLibraryList = publicLibraryList
    this.privateLibraryList = privateLibraryList
    this.purchasedPrograms = await this.loadAllPurchasePrograms()
    await this.loadAllBookmarks()
    setTimeout(() => {
      this.loadProgramGuideResults()
    }, 0)
  },

  methods: {
    ...mapActions([
      'loadUserObj',
      'loadInstitutionDetail',
      'loadInstitutionPackage',
      'searchForProgramGuides',
      'loadLibrariesForUser',
      'loadAllBookmarks',
      'loadCreateBookmarks',
      'loadDeleteBookmark',
      'saveProgramGuideSearchState',
      'loadPlanningStream',
      'loadAllPurchasePrograms'
    ]),

    showLoader () {
      this.loader = true
    },

    hideLoader () {
      this.loader = false
    },

    isCustomTagChecked (customTag) {
      let data = _.find(this.programGuideCustomTags, (item) => {
        return (item.isSelected && (item.key.toLowerCase() === customTag.key.toLowerCase()))
      })
      return (data !== undefined)
    },
    isModalityChecked (modality){
      if (this.modalityType.indexOf(modality) !== -1) {
        return true
      }
      return false
    },
    isFundingChecked (funding){
      if (this.fundingType.indexOf(funding) !== -1) {
        return true
      }
      return false
    },
    filterModalitySelected (facet, fieldName, isdelete){
      let index = this.modalityType.indexOf(facet)
      if (!isdelete && index === -1) {
        this.modalityType.push(facet)
      } else if (index > -1){
        this.modalityType.splice(index, 1)
      }
      this.filterSelected(facet, fieldName, isdelete)
    },
    filterFundingSelected (facet, fieldName, isdelete){
      let index = this.fundingType.indexOf(facet)
      if (!isdelete && index === -1) {
        this.fundingType.push(facet)
      } else if (index > -1){
        this.fundingType.splice(index, 1)
      }
      this.filterSelected(facet, fieldName, isdelete)
    },

    joinListWithCommas (stringList) {
      let str = []

      for (var i = 0; i < stringList.length; i++) {
        if (str.length === 0) {
          str = stringList[i]
        } else {
          str = str + ',' + stringList[i]
        }
      }
      return str
    },

    searchButtonClicked () {
      let searchTerms = this.searchTerms
      if (searchTerms && searchTerms.length > 0) {
        this.selectedSort = this.relevanceSort
      } else {
        this.selectedSort = this.titleSort
      }
      return this.loadProgramGuideResults()
    },

    loadProgramGuideResults () {
      this.saveProgramGuideSearchState({
        terms: this.searchTerms,
        sort: { clause: this.selectedSort },
        filter: this.filter,
        selectedFacetNames: this.selectedFacetNames,
        customIncomeMin: this.customIncomeMin,
        customIncomeMax: this.customIncomeMax
      })
      this.isResultsLoaded = false
      let loadSearchResults = this.searchForProgramGuides
      let filter = this.buildFilter()
      let facets = this.buildFacets()
      let isFacetResultsEmpty = this.isFacetResultsEmpty
      const searchInput = {
        terms: this.searchTerms,
        sort: this.selectedSort,
        source: this.source,
        from: 0,
        size: this.size,
        indexList: this.formattedIndexList,
        libraryList: this.formattedLibraryList,
        privateLibraryList: this.privateLibraryList,
        publicLibraryList: this.publicLibraryList,
        userId: this.userObj.uuid,
        facets: facets,
        filter: filter,
        facetNames: this.allFacetNames,
        selectedFacetNames: this.selectedFacetNames // NOTE: uncomment for dynamic faceting
        // selectedFacetNames: isFacetResultsEmpty ? this.selectedFacetNames : this.allFacetNames // NOTE: uncomment for "sticky" faceting
      }
      if (this.isStickyFacetsEnabled) {
        searchInput.selectedFacetNames = isFacetResultsEmpty ? this.selectedFacetNames : this.allFacetNames
      }
      loadSearchResults(searchInput).then(res => {
        setTimeout(() => {
          this.isResultsLoaded = true
          this.hideLoader()
          this.loadPlanningStream()
          this.showPage = true
        }, 0)
      })
    },

    goToProgramGuideDetail (programGuide) {
      if (!programGuide.cipCode || !programGuide.code) {
        return this.notifyFailure(this.navigationErrorMessage)
      }
      let routerParams = {
        cipCode: programGuide.cipCode,
        programGuideCode: programGuide.code,
        type: programGuide.type,
        returnTo: 'exploreProgramGuideResults',
        showBackToResultButton: true
      }
      return this.$router.push({ name: 'programGuideMenu', params: routerParams })
    },

    closeDescriptionModal (modalId) {
      let descriptionModal = modalId
      //this.$refs.descriptionModal.hide()
      this.$root.$emit('bv::hide::modal', descriptionModal)
    },

    getProgramGuideBookmark (programGuide) {
      let bookmarks = this.bookmarks
      if (!bookmarks || !bookmarks.length) {
        return false
      }
      let target = false
      bookmarks.forEach(bookmark => {
        if (bookmark.entityUuid === programGuide.uuid) {
          target = bookmark
        }
      })
      return target
    },
   alreadyPurchased (programGuide){
        let purchased = false
        this.purchasedPrograms.forEach(uuid => {
        if (uuid === 'ALL' || uuid === programGuide.uuid) {
          purchased = true
        }
      })
      return purchased
    },

    openAreaOfStudyDropDown () {
      this.showAreaOfStudyDropDown = true
    },

    closeAreaOfStudyDropDown () {
      this.showAreaOfStudyDropDown = false
    },

    openSubCategoryDropDown () {
      this.showSubCategoryDropDown = true
    },

    closeSubCategoryDropDown () {
      this.showSubCategoryDropDown = false
    },

    openCollegeDropDown () {
      this.showCollegeDropDown = true
    },

    closeCollegeDropDown () {
      this.showCollegeDropDown = false
    },

    openProgramLevelDropDown () {
      this.showProgramLevelDropDown = true
    },

    closeprogramLevelDropDown () {
      this.showProgramLevelDropDown = false
    },

    openIncomeRangeDropDown () {
      this.showIncomeRangeDropDown = true
    },

    closeIncomeRangeDropDown () {
      this.showIncomeRangeDropDown = false
    },

    openSortByDropDown () {
      this.showSortByDropDown = true
      this.isProgramSortByClicked = true
    },

    closeSortByDropDown () {
      this.showSortByDropDown = false
      this.isProgramSortByClicked = false
    },
    openOtherFilterDropDown () {
      this.isProgramOtherFilterClicked = true
    },

    closeOtherFilterDropDown () {
      this.isProgramOtherFilterClicked = false
    },

    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getModalityValue(key){
        let arr = this.programGuideMadalityTypeArray
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },
    getFundingValue(key){
        let arr = this.programGuideFundingTypeArray
        for(let i=0;i<arr.length;i++){
            if(arr[i].key===key){
                return arr[i].value
            }
        }
      return key
    },

    formatNumericVal (numValue) {
      return parseFloat(numValue).toFixed(1)
    },

    setImageWidth (imageId) {
      let getImageWidth = $('#img_' + imageId).width()
      let getImageHeight = $('#img_' + imageId).height()
      if (getImageWidth > getImageHeight) {
        return ''
      } else {
        return 'img_w_100'
      }
    },

    isTermFilterSelected (facet, fieldName) {
      let valuesToFilter = this.filter[fieldName]
      let fieldValue = facet.key
      return valuesToFilter && valuesToFilter.includes(fieldValue)
    },

    isCustomRangeFilterActive () {
      const medianIncomePerYear = this.facetFieldMap.programGuideIncomeRange
      let selectedRangeFilter = this.filter[medianIncomePerYear]
      return selectedRangeFilter && selectedRangeFilter.isCustom
    },

    isRangeFilterSelected (rangeFacet, fieldName) {
      let selectedRangeFilter = this.filter[fieldName].rangeInterval
      return selectedRangeFilter && selectedRangeFilter === rangeFacet.rangeInterval
    },

    isFilterSelected (facet, fieldName) {
      return this.isTermFilterSelected(facet, fieldName) || this.isRangeFilterSelected(facet, fieldName)
    },

    filterSelected (facet, facetName) {
      const fieldName = this.facetFieldMap[facetName]
      const fieldValue = facet.key || facet.rangeInterval
      const isRangeFacet = fieldName === this.facetFieldMap.programGuideIncomeRange
      const isCostRangeFacet = fieldName === this.facetFieldMap.programGuideCostRange
      if (isRangeFacet) {
        // NOTE only allow one range filter at a time
        this.filter[fieldName] = {
          from: facet.from,
          to: facet.to,
          rangeInterval: facet.rangeInterval,
          isCustom: facet.isCustom === true
        }
        if (!facet.isCustom) {
          this.customIncomeMin = ''
          this.customIncomeMax = ''
          this.$forceUpdate()
        }
        if (!this.selectedFacetNames.includes(facetName)) {
          this.selectedFacetNames.push(facetName)
        }
     } else if(isCostRangeFacet){
          this.filter[fieldName] = {
            from: facet.from,
            to: facet.to,
            rangeInterval: facet.rangeInterval
          }
          if (!this.selectedFacetNames.includes(facetName)) {
            this.selectedFacetNames.push(facetName)
          }
      } else if (this.isTermFilterSelected(facet, fieldName)) {
        this.filter[fieldName] = this.filter[fieldName].filter(v => v !== fieldValue)

        // remove the facetName from selected list if no other value in that category is selected
        // ex) facetName = 'department', this.filter.department = ['CSCI'] ==> selectedFacetNames = ['department']
        // ex2) facetName = 'department', this.filter.department = [] ==> selectedFacetNames = []
        const isFacetSelected = this.selectedFacetNames.includes(facetName)
        const isFacetUnused = this.filter[fieldName].length === 0
        if (isFacetSelected && isFacetUnused) {
          this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== facetName)
        }
      } else {
        this.filter[fieldName].push(fieldValue)
        if (!this.selectedFacetNames.includes(facetName)) {
          this.selectedFacetNames.push(facetName)
        }
      }
      // if not selected, add the value to the filter and selectedFacetNames list
      this.loadProgramGuideResults()
    },

    buildTermClause (fieldName, filterValues) {
      let clause = {
        'terms': {}
      }
      clause.terms[fieldName] = filterValues
      return clause
    },

    buildRangeClause (fieldName, from, to) {
      let clause = {'range': {}}
      clause.range[fieldName] = {}
      if (from) {
        clause.range[fieldName]['gte'] = from
      }
      if (to) {
        clause.range[fieldName]['lt'] = to
      }
      return clause
    },

    initializeSearchData () {
      this.searchTerms = this.programGuideSearchTerms || ''
      this.selectedFacetNames = this.programGuideSearchSelectedFacetNames || []
      this.customIncomeMin = this.programGuideSearchCustomIncomeMin || ''
      this.customIncomeMax = this.programGuideSearchCustomIncomeMax || ''
      if (this.programGuideSearchTerms)  {
        this.selectedSort = this.relevanceSort
      } else {
        this.selectedSort = this.titleSort // Always default to title sort intitially
      }
      let filter = this.programGuideSearchFilter
      if (this.isFilterEmpty(filter)) {
        Object.values(this.facetFieldMap).forEach(fieldName => {
          if ((fieldName === 'customTags.keyword')) {
            let values = []
            if (this.isCustomTagFilterEnabled) {
              this.customTagOptions.forEach(item => {
                values.push(item.key)
                item.isSelected = true
              })
            }
            filter[fieldName] = values
          } else {
            filter[fieldName] = []
          }
        })
      }
      if (filter.modalityType.length > 0) {
        filter.modalityType.forEach((item, i) => {
          this.programGuideMadalityTypeArray.forEach((mod, j) => {
            if (item === mod.key) {
              this.modalityType.push(mod)
            }
          })
        })
      }
      if (filter.fundingType.length > 0) {
        filter.fundingType.forEach((item, i) => {
          this.programGuideFundingTypeArray.forEach((funding, j) => {
            if (item === funding.key) {
              this.fundingType.push(funding)
            }
          })
        })
      }
      this.filter = filter
    },

    isFilterEmpty (filter) {
      let isEmpty = true
      filter = filter || this.filter
      Object.values(filter).forEach(filterValues => {
        isEmpty = isEmpty && !filterValues
      })
      return isEmpty
    },

    filterByBlankUserExternalId () {
      let filter = {
        'bool': {
          'must': [],
          'must_not': {
	          'exists': {
	            'field': 'userExternalId'
	          }
	        }
        }
      }
      return filter
    },

    buildFilter () {
      let elasticSearchFilter = this.filterByBlankUserExternalId()
      let filter = this.filter
      let buildTermClause = this.buildTermClause
      let buildRangeClause = this.buildRangeClause
      let medianIncomePerYear = this.facetFieldMap.programGuideIncomeRange
      let cost = this.facetFieldMap.programGuideCostRange
      Object.keys(filter).forEach(fieldName => {
        const isTermFacet = (fieldName !== medianIncomePerYear && fieldName !== cost)
        const isRangeFacet = !isTermFacet
        let filterValues = filter[fieldName]
        if (isTermFacet && filterValues && filterValues.length > 0) {
          elasticSearchFilter.bool.must.push(buildTermClause(fieldName, filterValues))
        } else if (isRangeFacet && filterValues.rangeInterval) {
          elasticSearchFilter.bool.must.push(buildRangeClause(fieldName, filterValues.from, filterValues.to))
        }
      })
      return elasticSearchFilter
    },

    getFacetFilter (facetName) {
      let facetFilter = {
        'bool': {
          'must': []
        }
      }
      const isFilterEmpty = this.isFilterEmpty()
      if (!isFilterEmpty && !this.selectedFacetNames.includes(facetName)) {
        let buildFilter = this.buildFilter()
        facetFilter.bool.must = facetFilter.bool.must.concat(buildFilter.bool.must)
        if (Object.keys(buildFilter.bool.must_not).length > 0) {
          facetFilter.bool['must_not'] = buildFilter.bool.must_not
        }
      }
      return facetFilter
    },

    buildFacet (field, order, facetName) {
      return {
        'aggs': {
          'termObj': {
            'terms': {
              'field': field,
              'order': order,
              'size': 1000
            }
          }
        },
        'filter': this.getFacetFilter(facetName)
      }
    },

    closeAllDropDowns () {
      this.closeAreaOfStudyDropDown()
      this.closeSubCategoryDropDown()
      this.closeCollegeDropDown()
      this.closeprogramLevelDropDown()
      this.closeIncomeRangeDropDown()
      this.closeSortByDropDown()
    },

    customRangeSelected () {
      // ignore ranges where either inputs are empty to avoid confusing UX.
      this.validateCustomRanges()
      if (!this.customIncomeMin && !this.customIncomeMax) {
        return this.isCustomRangeFilterActive() ? this.clearRangeFilter() : this.closeIncomeRangeDropDown()
      }
      let range = {from: this.customIncomeMin, to: this.customIncomeMax}
      range.rangeInterval = range.from + '-' + range.to
      if (!range.from) {
        range.rangeInterval = '< ' + range.to
      } else if (!range.to) {
        range.rangeInterval = '> ' + range.from
      }
      range.isCustom = true
      this.closeIncomeRangeDropDown()
      console.log('range: ', range.rangeInterval)
      this.filterSelected(range, 'programGuideIncomeRange')
    },

    clearRangeFilter () {
      const programGuideIncomeRange = 'programGuideIncomeRange'
      const medianIncomePerYear = this.facetFieldMap[programGuideIncomeRange]
      this.customIncomeMin = ''
      this.customIncomeMax = ''
      this.filter[medianIncomePerYear] = {}
      this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== programGuideIncomeRange)
      this.closeIncomeRangeDropDown()
      this.loadProgramGuideResults()
    },
    clearCostRangeFilter () {
      const cost = this.facetFieldMap['programGuideCostRange']
      this.filter[cost] = {}
      this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== cost)
      this.loadProgramGuideResults()
    },
    notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },

    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },

    async bookmarkProgramGuide (programGuide) {
      const bookmark = {
        'source': 'explore',
        'entityType': 'programguide',
        'entityTitle': programGuide.title,
        'entityUuid': programGuide.uuid,
        'institutionId': programGuide.institutionId,
        'userId': this.userObj.uuid
      }
      const response = await this.loadCreateBookmarks(bookmark)
      const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + programGuide.title + '\''
      const notify = response ? this.notifySuccess : this.notifyFailure
      notify(message)
      await this.loadAllBookmarks() // Refresh Vuex state to mark ProgramGuide as bookmarked
    },

    async deleteProgramGuideBookmark (programGuide) {
      await this.loadDeleteBookmark(programGuide.bookmark.uuid)
      this.notifySuccess('Successfully deleted bookmark \'' + programGuide.title + '\'')
      await this.loadAllBookmarks() // Refresh Vuex state to mark ProgramGuide as bookmarked
    },

    isBookmarked (programGuide) {
      return programGuide.bookmark && programGuide.bookmark.uuid
    },

    validateCustomRanges () {
      let customIncomeMin = this.customIncomeMin
      let customIncomeMax = this.customIncomeMax
      if (isNaN(customIncomeMin) || isNaN(customIncomeMax) || customIncomeMin < 0 || customIncomeMax < 0) {
        customIncomeMin = ''
        customIncomeMax = ''
      }
      this.customIncomeMin = customIncomeMin
      this.customIncomeMax = customIncomeMax
      this.$forceUpdate()
    },

    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },

    buildFacets () {
      const termOrder = {'_key': 'asc'}
      let buildFacet = this.buildFacet
      let getFacetFilter = this.getFacetFilter
      let facets = {
        'programGuideCategory': buildFacet('category.raw', termOrder, 'programGuideCategory'),
        'programGuideSubCategory': buildFacet('subCategory.raw', termOrder, 'programGuideSubCategory'),
        'programGuideCollege': buildFacet('colleges.raw', termOrder, 'programGuideCollege'),
        'programGuideLevel': buildFacet('programLevel.keyword', termOrder, 'programGuideLevel'),
        'programGuideCustomTag': buildFacet('customTags.keyword', termOrder, 'programGuideCustomTag'),
        'programGuideIncomeRange': {
          'aggs': {
	          'rangeObj': {
	            'range': {
	              'field': 'medianIncomePerYear',
	              'ranges': [
	              	{'to': 25000},
	              	{'from': 25000, 'to': 50000},
	              	{'from': 50000, 'to': 75000},
	              	{'from': 75000}
	              ]
	            }
	          }
	        },
	        'filter': getFacetFilter('programGuideIncomeRange')
              },
        'programGuideCostRange': {
          'aggs': {
            'rangeObj': {
              'range': {
                'field': 'cost',
                'ranges': [
                  {'to': 5000},
                  {'from': 5000, 'to': 10000},
                  {'from': 10000, 'to': 20000},
                  {'from': 20000}
                ]
              }
            }
          },
          'filter': getFacetFilter('programGuideCostRange')
          }
      }
      return facets
    },

    calculateCreditProgressClicked (programGuide, event) {
      this.selectedProgramGuide = programGuide
      this.creditProgressTargetId = event.target.id
      this.showCreditProgressPopup = true
    },

    selectedFilterCount () {
      if (this.isFilterEmpty(this.programGuideSearchFilter)) {
        return 0
      }
      let count = this.programGuideSearchFilter['category.raw'].length
      count += this.programGuideSearchFilter['subCategory.raw'].length
      count += this.programGuideSearchFilter['colleges.raw'].length
      count += this.programGuideSearchFilter['modalityType'].length
      count += this.programGuideSearchFilter['fundingType'].length
      count += (this.isCustomTagFilterEnabled ? this.programGuideSearchFilter['programLevel.keyword'].length : 0)
      count += this.programGuideSearchFilter['customTags.keyword'].length
      count += ((!_.isEmpty(this.programGuideSearchFilter.medianIncomePerYear)) ? 1 : 0)
      count += ((!_.isEmpty(this.programGuideSearchFilter.cost)) ? 1 : 0)
      return count
    }
  },
  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'packages': state => state.dashboard.packages,
      'programGuideFacetResults': state => state.explore.programGuideFacetResults,
      'programGuideSearchResults': state => state.explore.programGuideSearchResults,
      'bookmarks': state => state.explore.bookmarks,
      'programGuideSearchTerms': state => state.explore.programGuideSearchTerms,
      'programGuideSearchSort': state => state.explore.programGuideSearchSort,
      'programGuideSearchFilter': state => state.explore.programGuideSearchFilter,
      'programGuideSearchSelectedFacetNames': state => state.explore.programGuideSearchSelectedFacetNames,
      'programGuideSearchCustomIncomeMin': state => state.explore.programGuideSearchCustomIncomeMin,
      'programGuideSearchCustomIncomeMax': state => state.explore.programGuideSearchCustomIncomeMax,
      'planningStream': state => state.dashboard.stream,
      'total': state => state.explore.programTotal
    }),
    parentComponent () {
      return this
    },
    exploreProgramsFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showDescriptionOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultDescription) {
        return false
      }
      return exploreProgramsFlagMap.searchResultDescription.enabled
    },
    showMedianIncomeOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultMedianIncome) {
        return false
      }
      return exploreProgramsFlagMap.searchResultMedianIncome.enabled
    },
    medianIncomeResultLabel () {
      const defaultLabel = 'median income'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultMedianIncome) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.searchResultMedianIncome.label || defaultLabel
    },
    showJobPostingsOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultJobPosting) {
        return false
      }
      return exploreProgramsFlagMap.searchResultJobPosting.enabled
    },
    jobPostingsResultLabel () {
      const defaultLabel = 'job postings'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultJobPosting) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.searchResultJobPosting.label || defaultLabel
    },
    showGrowthRateOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultGrowthRate) {
        return false
      }
      return exploreProgramsFlagMap.searchResultGrowthRate.enabled
    },
    growthRateResultLabel () {
      const defaultLabel = 'growth'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultGrowthRate) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.searchResultGrowthRate.label || defaultLabel
    },
    showBookmarkOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultBookMark) {
        return false
      }
      return exploreProgramsFlagMap.searchResultBookMark.enabled
    },
    showProgramTypeTagOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultProgramTypeTag) {
        return false
      }
      return exploreProgramsFlagMap.searchResultProgramTypeTag.enabled
    },
    isSortByEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortBy) {
        return false
      }
      return exploreProgramsFlagMap.sortBy.enabled
    },
    isSortByRelevanceEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByRelevance) {
        return false
      }
      return exploreProgramsFlagMap.sortByRelevance.enabled
    },
    sortByRelevanceLabel () {
      const defaultLabel = 'Relevance'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByRelevance) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.sortByRelevance.label || defaultLabel
    },
    isSortByTitleEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByTitle) {
        return false
      }
      return exploreProgramsFlagMap.sortByTitle.enabled
    },
    sortByTitleLabel () {
      const defaultLabel = 'Title'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByTitle) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.sortByTitle.label || defaultLabel
    },
    isSortByMedianIncomeEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByMedianIncome) {
        return false
      }
      return exploreProgramsFlagMap.sortByMedianIncome.enabled
    },
    sortByMedianIncomeLabel () {
      const defaultLabel = 'Median Income'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByMedianIncome) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.sortByMedianIncome.label || defaultLabel
    },
    isSortByJobPostingEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByJobPosting) {
        return false
      }
      return exploreProgramsFlagMap.sortByJobPosting.enabled
    },
    sortByJobPostingsLabel () {
      const defaultLabel = 'Job Postings'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByJobPosting) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.sortByJobPosting.label || defaultLabel
    },
    isSortByGrowthRateEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByGrowthRate) {
        return false
      }
      return exploreProgramsFlagMap.sortByGrowthRate.enabled
    },
    sortByGrowthRateLabel () {
      const defaultLabel = 'Growth'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.sortByGrowthRate) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.sortByGrowthRate.label || defaultLabel
    },
    sortByOptions () {
      let options = []
      let sorts = this.sorts
      if (this.isSortByRelevanceEnabled) {
        sorts[0].name = this.sortByRelevanceLabel
        options.push(sorts[0])
      }
      if (this.isSortByTitleEnabled) {
        sorts[1].name = this.sortByTitleLabel
        options.push(sorts[1])
      }
      if (this.isSortByMedianIncomeEnabled) {
        sorts[2].name = this.sortByMedianIncomeLabel
        options.push(sorts[2])
      }
      if (this.isSortByJobPostingEnabled) {
        sorts[3].name = this.sortByJobPostingsLabel
        options.push(sorts[3])
      }
      if (this.isSortByGrowthRateEnabled) {
        sorts[4].name = this.sortByGrowthRateLabel
        options.push(sorts[4])
      }
      return options
    },
    isSearchBarEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchPrograms) {
        return false
      }
      return exploreProgramsFlagMap.searchPrograms.enabled
    },
    isAreaOfStudyEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectAreaOfStudy) {
        return false
      }
      return exploreProgramsFlagMap.selectAreaOfStudy.enabled
    },
    areaOfStudyLabel () {
      const defaultLabel = 'Area of Study'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectAreaOfStudy) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.selectAreaOfStudy.label || defaultLabel
    },

    isSubCategoryEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectSubCategory) {
        return false
      }
      return exploreProgramsFlagMap.selectSubCategory.enabled
    },
    subCategoryLabel () {
      const defaultLabel = 'Sub Category'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectSubCategory) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.selectSubCategory.label || defaultLabel
    },

    isCollegeEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectCollege) {
        return false
      }
      return exploreProgramsFlagMap.selectCollege.enabled
    },
    collegeLabel () {
      const defaultLabel = 'College'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectCollege) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.selectCollege.label || defaultLabel
    },

    isModalityEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.modalityFilter) {
        return false
      }
      return exploreProgramsFlagMap.modalityFilter.enabled
    },
    modalityLabel () {
      const defaultLabel = 'Modality'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.modalityFilter) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.modalityFilter.label || defaultLabel
    },

    isCostRangeEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.costRangeFilter) {
        return false
      }
      return exploreProgramsFlagMap.costRangeFilter.enabled
    },
    costRangeLabel () {
      const defaultLabel = 'Cost'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.costRangeFilter) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.costRangeFilter.label || defaultLabel
    },
    isFundingFilterEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.fundingFilter) {
        return false
      }
      return exploreProgramsFlagMap.fundingFilter.enabled
    },
    fundingLabel () {
      const defaultLabel = 'Funding Available'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.fundingFilter) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.fundingFilter.label || defaultLabel
    },

    isProgramLevelEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectProgramLevel) {
        return false
      }
      return exploreProgramsFlagMap.selectProgramLevel.enabled
    },
    programLevelLabel () {
      const defaultLabel = 'Program Level'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectProgramLevel) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.selectProgramLevel.label || defaultLabel
    },
    isIncomeRangeEnabled () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectIncomeRange) {
        return false
      }
      return exploreProgramsFlagMap.selectIncomeRange.enabled
    },
    incomeRangeLabel () {
      const defaultLabel = 'Income Range'
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.selectIncomeRange) {
        return defaultLabel
      }
      return exploreProgramsFlagMap.selectIncomeRange.label || defaultLabel
    },
    isCustomTagFilterEnabled () {
      let customTagsFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_CUSTOM_TAGS_FEATURE_ID]
      if (customTagsFeature) {
        return customTagsFeature.enabled
      }
      return false
    },
    customTagOptions () {
      let customTagOptions = []
      let customTagsFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_CUSTOM_TAGS_FEATURE_ID]
      if (customTagsFeature) {
        let flags = customTagsFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.enabled) {
            let text = (flag.label && flag.label.length > 0) ? flag.label : flag.title
            customTagOptions.push({key: text, label: text + ' Pathways'})
          }
        }
      }
      return customTagOptions
    },
    formattedIndexList () {
      let allIndices = this.allIndexes
      return this.joinListWithCommas(allIndices)
    },
    formattedLibraryList () {
      let allFolders = this.allFolders
      return this.joinListWithCommas(allFolders)
    },
    programGuideCustomTags () {
      return this.formattedFacetResults.programGuideCustomTag
    },
    programGuideMadalityTypeArray () {
      return [{key:"online", value:"Online"}, {key:"inperson", value:"In person"}, {key:"hybrid", value:"Hybrid"}]
    },
    programGuideFundingTypeArray () {
      return [{key:"free", value:"Free"}, {key:"full", value:"Fully funded"}, {key:"partial", value:"Financial Aid"}]
    },
    formattedFacetResults () {
      let formattedFacetResults = {}
      let facetResults = this.programGuideFacetResults
      let facetFieldMap = this.facetFieldMap
      let isTermFilterSelected = this.isTermFilterSelected
      let isRangeFilterSelected = this.isRangeFilterSelected
      let currencyLabel = this.currencyLabel
      let addCommaInNumber = this.addCommaInNumber
      this.allFacetNames.forEach((facetName) => {
        const fieldName = facetFieldMap[facetName]
        let facetResult = (facetResults && facetResults[facetName]) ? _.cloneDeep(facetResults[facetName]) : {}
        if (facetResult && Object.keys(facetResult).length > 0) {
          let isRangeFacet = Object.keys(facetResult).includes('rangeObj')
          if (isRangeFacet) {
            facetResult = _.cloneDeep(facetResult.rangeObj.buckets)
            facetResult.forEach((range) => {
              if (!range.from) {
                let formatted = addCommaInNumber(range.to)
                range.rangeInterval = '< ' + formatted
                range.label = '< ' + currencyLabel + formatted
              } else if (!range.to) {
                let formatted = addCommaInNumber(range.from)
                range.rangeInterval = '> ' + formatted
                range.label = '>= ' + currencyLabel + formatted
              } else if (range.to && range.from) {
                range.rangeInterval = range.from + '-' + range.to
                range.label = (currencyLabel + addCommaInNumber(range.from)) + '-' + (currencyLabel + addCommaInNumber(range.to))
              }
              range.isSelected = isRangeFilterSelected(range, fieldName)
            })
          } else {
            facetResult = facetResult.termObj.buckets
            facetResult.forEach((termFacet) => {
              termFacet.isSelected = isTermFilterSelected(termFacet, fieldName)
            })
          }
        }
        formattedFacetResults[facetName] = facetResult
      })
      return formattedFacetResults
    },
    formattedResults () {
      let formatted = []
      let results = this.programGuideSearchResults
      if (!results || results.length <= 0) {
        return formatted
      }
      let getBookmark = this.getProgramGuideBookmark
      results.forEach(function (programGuide) {
        let elasticSearchDocument = programGuide.elasticSearchDocument
        programGuide.cipCode = elasticSearchDocument.cipCode
        programGuide.code = elasticSearchDocument.code
        programGuide.institutionId = elasticSearchDocument.institutionId
        programGuide.medianIncomePerYear = elasticSearchDocument.medianIncomePerYear
        programGuide.growthRate = elasticSearchDocument.growthRate
        programGuide.totalJobPostings = elasticSearchDocument.totalJobPostings
        programGuide.thumbnailURL = elasticSearchDocument.thumbnailURL
        programGuide.bookmark = getBookmark(programGuide)
        programGuide.lowestPrice = elasticSearchDocument.lowestPrice
        programGuide.lowestPriceCurrency = elasticSearchDocument.lowestPriceCurrency
        programGuide.cost = elasticSearchDocument.cost
        programGuide.modalityType = elasticSearchDocument.modalityType
        programGuide.fundingType = elasticSearchDocument.fundingType
        programGuide.freeProgram = elasticSearchDocument.freeProgram
        programGuide.pragyaProgram = elasticSearchDocument.pragyaProgram
        programGuide.disbleLMI = elasticSearchDocument.disbleLMI
        programGuide.paymentProcessedOutOfPragya = elasticSearchDocument.paymentProcessedOutOfPragya
        formatted.push(programGuide)
      })
      return formatted
    },
    allFacetNames () {
      return Object.keys(this.facetFieldMap)
    },
    fieldsToFilter () {
      return Object.values(this.facetFieldMap)
    },
    currencyLabel () {
      return '$'
    },
    relevanceSort () {
      return this.sorts[0].clause
    },
    titleSort () {
      return this.sorts[1].clause
    },
    isFacetResultsEmpty () {
      let isEmpty = true
      let formattedFacetResults = this.formattedFacetResults
      this.allFacetNames.forEach(facetName => {
        let facetResult = formattedFacetResults[facetName]
        if (facetName === 'programGuideIncomeRange' && facetResult.length > 0) {
          facetResult.forEach((range) => {
            isEmpty = isEmpty && range.doc_count === 0
          })
        } else {
          isEmpty = isEmpty && (!facetResult || facetResult.length === 0)
        }
      })
      return isEmpty
    },
    exploreSearchFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_FEATURE_ID
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    isStickyFacetsEnabled () {
      let exploreSearchFlagMap = this.exploreSearchFlagMap
      if (!exploreSearchFlagMap || !exploreSearchFlagMap.enableStickyFacets) {
        return false
      }
      return this.exploreSearchFlagMap.enableStickyFacets.enabled
    },
    showFacetCounts () {
      let exploreSearchFlagMap = this.exploreSearchFlagMap
      if (!exploreSearchFlagMap || !exploreSearchFlagMap.showFacetCounts) {
        return false
      }
      return this.exploreSearchFlagMap.showFacetCounts.enabled
    },
    showCalculateRequiredCreditOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultCalculateRequiredCredit) {
        return false
      }
      return exploreProgramsFlagMap.searchResultCalculateRequiredCredit.enabled
    },
    isStudentLogin () {
      let role = this.userObj.roles[0].role
      return (role === 'Student')
    },
    exploreProgramsLabel () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
       if (exploreFeature) {
         for (var i = 0; i < exploreFeature.flags.length; i++) {
           if (exploreFeature.flags[i].title === 'useProgramLongText') {
             if (exploreFeature.flags[i].isEnabled) {
               return exploreFeature.flags[i].label
             }
           }
         }
       }
       return 'program'
   },
   exploreProgramsLabelPlural () {
     let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (exploreFeature) {
        for (var i = 0; i < exploreFeature.flags.length; i++) {
          if (exploreFeature.flags[i].title === 'useProgramLongText') {
            if (exploreFeature.flags[i].isEnabled) {
              return exploreFeature.flags[i].label + 's'
            }
          }
        }
      }
      return 'programs'
   }
  },
  watch: {
    showAreaOfStudyDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeSubCategoryDropDown()
        this.closeCollegeDropDown()
        this.closeprogramLevelDropDown()
        this.closeIncomeRangeDropDown()
        this.closeSortByDropDown()
      }
    },

    showSubCategoryDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeAreaOfStudyDropDown()
        this.closeCollegeDropDown()
        this.closeprogramLevelDropDown()
        this.closeIncomeRangeDropDown()
        this.closeSortByDropDown()
      }
    },

    showCollegeDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeSubCategoryDropDown()
        this.closeAreaOfStudyDropDown()
        this.closeprogramLevelDropDown()
        this.closeIncomeRangeDropDown()
        this.closeSortByDropDown()
      }
    },

    showProgramLevelDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeSubCategoryDropDown()
        this.closeCollegeDropDown()
        this.closeAreaOfStudyDropDown()
        this.closeIncomeRangeDropDown()
        this.closeSortByDropDown()
      }
    },
    showIncomeRangeDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeSubCategoryDropDown()
        this.closeCollegeDropDown()
        this.closeprogramLevelDropDown()
        this.closeAreaOfStudyDropDown()
        this.closeSortByDropDown()
      }
    },
    showSortByDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeSubCategoryDropDown()
        this.closeCollegeDropDown()
        this.closeprogramLevelDropDown()
        this.closeAreaOfStudyDropDown()
        this.closeIncomeRangeDropDown()
      }
    },
    selectedSort (newSort, oldSort) {
      if ((newSort.length > 0) && (oldSort.length > 0)) {
        this.loadProgramGuideResults()
      }
    }
  }
}
</script>

<style scoped>
  .entity_title {
    text-align: center;
    padding: 28px 0;
    font-size: 25px;
    color: #fff;
    font-family: robotoSlab_Light,Serif;
    font-weight: 800;
    width: 35%;
  }

  .item-list {
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100vh - 210px);
  }
  body {
    overflow-y: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreProgramResults.vue